function navigateZoom(dialog, direction) {
  const zoom = dialog.closest('zoom-dialog');
  const buttons = [...dialog.querySelectorAll('.dialog-thumbnails-list__thumbnail')];
  if (!zoom || buttons.length < 2) return;
  const current = Math.max(0, buttons.findIndex(button => button.getAttribute('aria-selected') === 'true'));
  zoom.selectThumbnail((current + direction + buttons.length) % buttons.length);
}
document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-tis-zoom-step]');
  const dialog = button?.closest('dialog');
  if (dialog) navigateZoom(dialog, Number(button.dataset.tisZoomStep));
});
document.addEventListener('keydown', event => {
  if (!(event.target instanceof Element)) return;
  const dialog = event.target.closest('media-gallery[data-tis-color] dialog[open]');
  if (!dialog || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
  event.preventDefault();
  navigateZoom(dialog, event.key === 'ArrowRight' ? 1 : -1);
});
